import { connectRouter } from 'connected-react-router'
import type { RouterState } from 'connected-react-router'
import { combineReducers } from 'redux'
import type { History } from 'history'
import type { ICommonState } from '@/store/reducers/common.reducer'
import commonReducer from './common.reducer'
import authReducer from './auth.reducer'
import type { IAuthState } from '@/store/models/auth.model'
import statisticsReducer from './statistics.reducer'
import type { IStatistics } from '@/store/models/statistics.model'
import tableEditReducer from './tableEdit.reducer'
import type { IDataEditState } from '@/store/models/tableEdit.model'

export interface IAppState {
    router: RouterState
    common: ICommonState
    auth: IAuthState
    statistics: IStatistics
    tableEditData: IDataEditState
}

const createRootReducer = (history: History): any =>
    combineReducers({
        router: connectRouter(history),
        common: commonReducer,
        auth: authReducer,
        statistics: statisticsReducer,
        tableEditData: tableEditReducer
    })

export default createRootReducer
